export const productDetailPriceHelper = {
    divClasses: ['product_sale', 'product_origin'],
    h2Classes: ['txt_sale', 'txt_origin'],
    prices: [],
    standards: [],
    setPrice: function (displayPrices) {
        this.prices = displayPrices;
    },
    setStandards: function (standards) {
        this.standards = standards;
    },
    getDivClass: function (displayBoth) {
        return displayBoth ? this.divClasses[0] : this.divClasses[1];
    },
    getH2Class: function (displayBoth) {
        return displayBoth ? this.h2Classes[0] : this.h2Classes[1];
    },
    getAreas: function () {
        return $('.js_frontend_price_area');
    },
    getPriceElements: function () {
        return this.getAreas().find('.js_price');
    },
    getOnsalePriceElements: function () {
        return this.getAreas().find('.js_onsale_price');
    },
    getPriceSpans: function () {
        return this.getAreas().find('.js_price_span');
    },
    getOnsalePriceSpans: function () {
        return this.getAreas().find('.js_onsale_price_span');
    },
    getPointElements: function () {
        return this.getAreas().find('.js_points');
    },
    init: function () {
        pricesPool.add(this.prices);
        pointsPool.add(this.standards)
    },
    updatePrice: function (id) {
        id = id || 0;
        this._updateDivClass(id);
        this._updatePriceElements(id);
        this._updatePriceSpan(id);
        this._updateH2Class(id);
        this._updateOnsalePriceSpan(id);
        this._updatePointsElement(id);
    },
    _updateDivClass: function (id) {
        var areas = this.getAreas();
        $.each(this.divClasses, function (key, className) {
            areas.removeClass(className);
        });

        areas.addClass(this.getDivClass(pricesPool.get(id).displayBothPrices()));
    },
    _updatePriceElements: function (id) {
        var display = pricesPool.get(id).displayBothPrices();

        if (display) {
            this.getPriceElements().css('display', 'inline');
        } else {
            this.getPriceElements().css('display', 'none');
        }
    },
    _updatePriceSpan: function (id) {
        this.getPriceSpans().html(pricesPool.get(id).getPrice());
    },
    _updateH2Class: function (id) {
        var elements = this.getOnsalePriceElements();
        $.each(this.h2Classes, function (key, className) {
            elements.removeClass(className);
        });

        elements.addClass(this.getH2Class(pricesPool.get(id).displayBothPrices()));
    },
    _updateOnsalePriceSpan: function (id) {
        this.getOnsalePriceSpans().html(pricesPool.get(id).getRealPrice());
    },
    _updatePointsElement: function (id) {
        if (id === 0) {
            // 初始值
            id = Object.keys(pointsPool.all())[0];
        }
        this.getPointElements().html(pointsPool.get(id));
    }
};

let pricesPool = {
    pool: {},
    add: function (prices) {
        $.each(prices, function (id, price) {
            price = this._createPrice(price);
            this.pool[price.getId()] = price;
        }.bind(this))
    },
    get: function (id) {
        return this.pool[id];
    },
    all: function () {
        return this.pool;
    },
    _createPrice: function (price) {
        return {
            price: price,
            getId: function () {
                return parseInt(this.price.id);
            },
            getPrice: function () {
                return this.price.price;
            },
            getRealPrice: function () {
                return this.price.realPrice;
            },
            displayBothPrices: function () {
                return this.price.displayBothPrices;
            }
        }
    }
};

let pointsPool = {
    pool: {},
    add: function (productStandards) {
        $.each(productStandards, function (index, productStandard) {
            this.pool[productStandard.id] = productStandard.points;
        }.bind(this))
    },
    get: function (id) {
        return this.pool[id];
    },
    all: function () {
        return this.pool;
    },
}
